import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { COMMON_CONSTANTS_SETTING } from 'src/app/common/constants/common-constants';
import { AuthenticationService } from 'src/app/common/services/authentication.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit{

  settingOptions = COMMON_CONSTANTS_SETTING;
  isreportIssue: boolean = false;


 SettingList: any = [
  // { iconClass: "managementIcon", displayLabel: "User Management", value: this.settingOptions.UserManagement, hasAccess: false },
  // { iconClass: "projectManagementIcon", displayLabel: "Project Management", value: this.settingOptions.ProjectManagement, hasAccess: false },
  // { iconClass: "dataUploadIcon", displayLabel: "Data Upload Module", value: this.settingOptions.DataUpload, hasAccess: false },
  { iconClass: "exportDownloadIcon", displayLabel: "Export Downloads", value: this.settingOptions.ExportDownload, hasAccess: false },
  { iconClass: "reportIssueIcon", displayLabel: "Report An Issue", value: this.settingOptions.ReportIssue, hasAccess: false},
  { iconClass: "logoutIcon", displayLabel: "Log Out", value: this.settingOptions.Logout, hasAccess: false },
]


  @Output() OnSettingClick = new EventEmitter<string>();
 constructor( private _authenticateService: AuthenticationService) { }

  settingSlide = false;

  ngOnInit() {
    setTimeout(() => this.settingSlide = true, 300);
  }

  onToggleSettingSlide(item: string) {
    if(item=='logout'){
      this._authenticateService.logout();
    }
    this.settingSlide = false;
    // Wait for the animation to complete before emitting
    setTimeout(() => this.OnSettingClick.emit(item), 300);
  }

  
}
